function setInputValidateState(input) {
    const errorCode = input.intlTelInput.getValidationError();
    const allowEmpty = input.required !== true && input.value === '';

    let error = '';

    const errorCodeKey = Object.keys(window.intlTelInputUtils?.validationError || {}).find(
        (key) => window.intlTelInputUtils.validationError[key] === errorCode
    );

    if (input.intlTelInput.isValidNumberPrecise() || allowEmpty) {
        error = '';
    } else {
        error =
            window.translate(`phone-validation.${errorCodeKey}`) ||
            window.translate('phone-validation.DEFAULT');
    }

    const inputCommonParentWithLabel = input.closest('.iti').parentNode;

    if (error === '') {
        inputCommonParentWithLabel.classList.add('form-control-valid');
        inputCommonParentWithLabel.classList.remove('form-control-invalid');
    } else {
        inputCommonParentWithLabel.classList.remove('form-control-valid');
        inputCommonParentWithLabel.classList.add('form-control-invalid');
    }

    input.setCustomValidity(error);

    return !error;
}

const telInputValidate = (telInputElement) => {
    setInputValidateState(telInputElement);

    if (telInputElement.intlTelInput.isValidNumberPrecise()) {
        telInputElement.value = telInputElement.intlTelInput.getNumber();
        telInputElement.dispatchEvent(new Event('input'));
    }
};

async function telInput(telInputElement) {
    await import('intl-tel-input/build/css/intlTelInput.css');
    const intlTelInput = await import('intl-tel-input');

    const isInternational = window.config.language.region === 'US';

    telInputElement.intlTelInput = intlTelInput.default(telInputElement, {
        // showSelectedDialCode: false,
        // separateDialCode: false,
        // formatAsYouType: true,
        // autoInsertDialCode: true,
        showSelectedDialCode: false,
        formatAsYouType: false,
        initialCountry: isInternational ? 'auto' : window.config.language.region.toLowerCase(),
        // nationalMode: false,
        geoIpLookup: async (success) => {
            const response = await fetch(
                'https://ipgeolocation.abstractapi.com/v1/?api_key=6f2cf16c14f84e3bb9691775e53dfb38'
            );

            const data = await response.json();

            const countryCode = data.country_code;

            success(countryCode);
        },
        formatOnDisplay: false,
        preferredCountries: ['pl', 'gb', 'cz', 'sk', 'hu', 'ro', 'bg', 'hr', 'gr', 'de'],
        utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.3.7/build/js/utils.js',
    });

    telInputElement.intlTelInput.promise.then(() => {
        const button = telInputElement.closest('form')?.querySelector('button[type="submit"]');

        if (telInputElement.value) {
            // format initial value if present
            telInputValidate(telInputElement);
        }

        if (button?.disabled) {
            button.disabled = false;
        }
    });

    telInputElement.checkValidity = () => setInputValidateState(telInputElement);

    telInputElement.addEventListener('change', () => {
        telInputValidate(telInputElement);
    });

    telInputElement.addEventListener('input', () => setInputValidateState(telInputElement));

    // Handle field if .form-floating is present
    const formFloating = telInputElement.closest('.form-floating');

    const formFloatingValueChecker = (targetElement) => {
        if (targetElement.value !== '') {
            targetElement.closest('.form-floating').classList.add('form-floating-filled');
        } else {
            targetElement.closest('.form-floating').classList.remove('form-floating-filled');
        }
    };

    if (formFloating) {
        formFloating.classList.add('form-floating-tel');

        formFloatingValueChecker(telInputElement);

        telInputElement.addEventListener('input', () => {
            formFloatingValueChecker(telInputElement);
        });

        telInputElement.addEventListener('focus', () => {
            telInputElement.closest('.form-floating').classList.add('form-floating-focus');
        });

        telInputElement.addEventListener('focusout', () => {
            telInputElement.closest('.form-floating').classList.remove('form-floating-focus');

            formFloatingValueChecker(telInputElement);
        });
    }

    const setLabelInputPositionAndValidateState = (telInputEvent) => {
        const input = telInputEvent.target ?? telInputEvent;
        setInputValidateState(input);

        // TODO 0.75 rem is bootstrap default padding, should be fetched somehow
        if (formFloating) {
            const el = formFloating.querySelector('label');
            el.style.paddingLeft = `calc(${input.style.paddingLeft} + 0.75rem)`;
        }
    };

    telInputElement.addEventListener('countrychange', setLabelInputPositionAndValidateState);

    setLabelInputPositionAndValidateState(telInputElement);
}

function telInputHandler(container, qs) {
    const telInputs = (container ?? document).querySelectorAll(
        qs ?? 'input[type="tel"]:not(.js-disable-intl-tel)'
    );

    if (telInputs.length > 0) {
        telInputs.forEach((telInputElement) => {
            if (!telInputElement.dataset.initialised) {
                telInput(telInputElement);
                /* eslint-disable no-param-reassign */
                telInputElement.dataset.initialised = true;
                /* eslint-enable no-param-reassign */
            }
        });
    }
}

export default telInputHandler;
